import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot
} from '@angular/router';
import { AuthenticationService } from 'app/helpers/authentication.service';
import { CrudService } from 'app/shared/crud-service';
import { EnumFuncoes } from "app/shared/enum.service";
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { UserGroupDTO } from './grupo-usuarios.model';

@Injectable({
    providedIn: 'root'
  })
  export class GrupoUsuariosService extends CrudService<UserGroupDTO> implements Resolve<any> {
    constructor(protected http: HttpClient,
                private _authService: AuthenticationService) {
        super(http, `${environment.apiUrl2}/v1/user-group`); // VERIFICAR A ROTA
    }
  
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        return new Promise<void>((resolve, reject) => {
            Promise.all([this.listAll()]).then(() => {
                resolve();
            }, reject);
        });
    }

    listAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${environment.apiUrl2}/v1/user-group/list`, {accountId: this._authService.currentUserValue.accountId}).subscribe(
                (response: any) => {
                     // console.log(response);
                    this.Arraydata = response;
                    this.onDataChanged.next(this.Arraydata);
                    resolve(response);
                }, reject);
        });
    }


    listPermissions(token?): Promise<any> {
        return new Promise((resolve, reject) => {

            const headers = new HttpHeaders({
                    'Authorization': `Bearer ${token}`
            });

            this.http.get(`${environment.apiUrl2}/v1/user-group/list/permission?UserGroupId=${this._authService.currentUserValue.userDetails.userGroupId}`, { headers }).subscribe(
                (response: any) => { 
                    this.Arraydata = response;

                    const requiredIDs = [38, 39, 67, 76, 113, 130, 131, 132, 135]; 
                    response.forEach((element: any) => {
                        if (requiredIDs.includes(element.companySystemModuleItemId)) {
                            element.canDelete = true;
                            element.canRead = true;
                            element.canWrite = true;
                        }

                        if ([35, 114].includes(element.companySystemModuleItemId)) {
                            element.canDelete = false;
                            element.canRead = false;
                            element.canWrite = false;
                        }
                    });

                    requiredIDs.forEach(id => {
                        const exists = response.some(item => item.companySystemModuleItemId === id);
                        if (!exists) {
                            response.push({
                                companySystemModuleItemId: id,
                                canDelete: true,
                                canRead: true,
                                canWrite: true,
                                id: 0,
                                userGroupId: this._authService.currentUserValue.userDetails.userGroupId,
                            });
                        }

                    });
                    resolve(response);
                }, reject);
        });
    }

    listPermissionsByGroupID(IdGroup): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.apiUrl2}/v1/user-group/list/permission?UserGroupId=${IdGroup}`).subscribe(
                (response: any) => {
                    const requiredIDs = [38, 39, 67, 76, 113, 130, 131, 132, 135];
                    response.forEach((element: any) => {
                        if (requiredIDs.includes(element.companySystemModuleItemId)) {
                            element.canDelete = true;
                            element.canRead = true;
                            element.canWrite = true;
                        }
                    });

                    requiredIDs.forEach(id => {
                        const exists = response.some(item => item.companySystemModuleItemId === id);
                        if (!exists) {
                            response.push({
                                companySystemModuleItemId: id,
                                canDelete: true,
                                canRead: true,
                                canWrite: true,
                                id: 0,
                                userGroupId: IdGroup,
                            });
                        }
                    });
                    
                    resolve(response);
                }, reject);
        });
    }

    registerPermission(record: any): Promise<any> {        
        return new Promise((resolve, reject) => {
            this.http.post(`${environment.apiUrl2}/v1/user-group/register/permission`, record, {responseType: 'text'}).subscribe(
                (response: any) => {
                    resolve(response);
                },
                reject => {
                }
            );
        });
    }

    updatePermission(record: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.put(`${environment.apiUrl2}/v1/user-group/edit/permission`, record, {responseType: 'text'}).subscribe(
                (response: any) => {
                    resolve(response);
                },
                reject => {
                }
            );
        });
    }

    getUserGroupById(record: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${environment.apiUrl2}/v1/user-group/details`, record).subscribe(
                (response: any) => {
                    resolve(response);
                },
                reject => {
                }
            );
        });
    }
  }
